import { ComputedNotifications, NotificationConfig, NotificationTypeId } from '../types';

/**
 * Типы нотификаций для primary row (верхняя строка) и secondary row (нижняя строка)
 */
const PRIMARY_TYPES = new Set<NotificationTypeId>(['mute-microphone', 'mute-camera', 'mute-both', 'reaction-hand']);
const SECONDARY_TYPES = new Set<NotificationTypeId>(['waiting-room', 'summarization', 'recording']);

/**
 * Группирует активные нотификации по строкам (primary/secondary).
 *
 * Primary row: отдельные нотификации с gap между ними
 * Secondary row: объединённая нотификация с разделителями
 *
 * @param activeTypes - массив активных NotificationTypeId
 * @param getConfig - функция получения конфига по ID (для тестируемости)
 * @returns объект с массивами primary и secondary конфигов
 */
export function computeNotifications(
    activeTypes: NotificationTypeId[],
    getConfig: (id: NotificationTypeId) => NotificationConfig
): ComputedNotifications {
    const primary: NotificationConfig[] = [];
    const secondary: NotificationConfig[] = [];

    for (const type of activeTypes) {
        const config = getConfig(type);

        if (PRIMARY_TYPES.has(type)) {
            primary.push(config);
        } else if (SECONDARY_TYPES.has(type)) {
            secondary.push(config);
        }
    }

    return { primary, secondary };
}
